import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './ticket-sites.module.scss'
import SiteInfoCard from './SiteInfoCard'
import SitecostForm from './SiteCostForm'

export default function TicketSiteItem ({
  ticketSite,
  index,
  totalSites,
  siteInfo,
  hasSiteCost,
  siteCostNote,
  expandedSiteCost,
  setExpandedSiteCost,
  onSubmitCost,
  saveDisabled,
  onRemove
}) {
  const handleAddCostClick = (id) => {
    setExpandedSiteCost([...expandedSiteCost, id])
  }

  return (
    <li key={ticketSite.id} className={styles.siteItemContainer}>
      <div className={styles.siteRow}>
        <div className={classNames(styles.siteItem, { [styles.lastSiteItem]: index === totalSites - 1 })}>
          <SiteInfoCard siteInfo={siteInfo} sitecostVisible={hasSiteCost} ticketSite={ticketSite} />
          <button
            type='button'
            className={classNames(
              'dis-btn dis-btn-sm',
              { 'dis-btn-success': siteCostNote?.cost === null, 'btn-primary-dk': siteCostNote?.cost !== null },
              styles.costAddButton
            )}
            onClick={() => handleAddCostClick(ticketSite.id)}>
            {siteCostNote?.cost !== null ? 'Edit Site Cost' : 'Add Site Cost'}
          </button>
        </div>

        {expandedSiteCost.includes(ticketSite.id) && (
          <div className={styles.siteFormContainer}>
            <SitecostForm
              onSubmit={onSubmitCost}
              disabled={saveDisabled}
              siteId={ticketSite.id}
              initialValues={siteCostNote}
              onClose={() =>
                setExpandedSiteCost(expandedSiteCost.filter((item) => item !== ticketSite.id))
              }
            />
          </div>
        )}
      </div>

      <button className={styles.removeBtn} type='button' onClick={() => onRemove(ticketSite.id)}>
        <i className={classNames('material-icons', styles.removeIcon)}>close</i>
      </button>
    </li>
  )
}

TicketSiteItem.propTypes = {
  ticketSite: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  totalSites: PropTypes.number.isRequired,
  siteInfo: PropTypes.object.isRequired,
  hasSiteCost: PropTypes.bool.isRequired,
  siteCostNote: PropTypes.object,
  expandedSiteCost: PropTypes.array.isRequired,
  setExpandedSiteCost: PropTypes.func.isRequired,
  onSubmitCost: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired
}
